<button type="submit" class="button is-primary" (click)="Search()" style="border-bottom-right-radius: 10px; border-top-right-radius: 10px;">
    <i class="fa fa-search fa-xs"></i>
</button>
